import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    container: {
        "& > .MuiGrid-item:first-of-type": {
            paddingTop: theme.spacing(4),
        },
        width: "auto",
    },
}));
